module.exports = __webpack_public_path__ + "static/pubconflondon19-336dc4b33571326a420776c40edc956a.jpeg";